import classNames from 'classnames';
import { textStyles } from '../style/text-styles';

export const Label = (props: React.ComponentPropsWithoutRef<'label'>) => {
  return (
    <label {...props} />
  );
};

export const HelperText = ({
  className = '',
  ...props
}: React.ComponentPropsWithoutRef<'span'>) => {
  return (
    <span className={classNames(textStyles.cHelperText, className)} {...props} />
  );
};
